
  import {Component, Vue} from "vue-property-decorator";
  import {
    AuditFlowDto,
    AuditFlowType,
    AuditNodeDto,
    AuditUserLogDto,
    AuditUserLogStatus,
    AuditUserLogType
  } from "@/api/appService";
  import api from '@/api';
  import moment from "moment";


  function getLogStatusColor(log:AuditUserLogDto){
    if(log.status === AuditUserLogStatus.Back){
      return '#ea7077';
    } else if(log.status === AuditUserLogStatus.Reject){
      return '#f00';
    } else if(log.status === AuditUserLogStatus.Pass){
      return '#8ce78c';
    } else if(log.status === AuditUserLogStatus.Continue){
      return '#3f93b0';
    } else {
      return '#87939a';
    }
  }

  interface LevelNode {
    level: number;
    nodes:AuditNodeItem[]
  }

  class AuditNodeItem {
    private readonly _node:AuditNodeDto;
    private readonly _log?:AuditUserLogDto;


    constructor(node:AuditNodeDto,allLogs:AuditUserLogDto[]) {
      this._node = node;
      let logs = allLogs.filter(s=>s.auditNodeId === node.id).sort((s1,s2)=>s1.id! - s2.id!);
      if(logs && logs.length){
        this._log = logs[0];
      }
    }

    getTagColor(){
      if(this._log){
        return getLogStatusColor(this._log);
      } else {
        return '#87939a'; // 灰
      }
    }

    get isAudited(){
      return !!this._log;
    }

    getStatusSummary(auditFlow:AuditFlowDto,levelNode:LevelNode){
      if(!this._log){
        if(auditFlow.type === AuditFlowType.AudtitOne && levelNode.nodes.some(s=>s.node.id!==this.node.id && s.isAudited)){
          return '已有人审核，自动跳过'
        } else {
          return '等待';
        }



      }

      if(this._log.status === AuditUserLogStatus.Continue){
        return '继续'
      } else if(this._log.status === AuditUserLogStatus.Pass){
        return '审批通过'
      } else if(this._log.status === AuditUserLogStatus.Reject){
        return '审批拒绝'
      } else if(this._log.status === AuditUserLogStatus.Back){
        return '退回'
      }
    }

    get node(){
      return this._node;
    }

    get log(){
      return this._log;
    }

    get auditObject(){
      if(this.node.roleId){
        return `角色:${this.node.roleName}`;
      } else {
        return `指定人:${this.node.userName}`
      }
    }


  }

  @Component
  export default class AuditFlowDetail extends Vue {


    private hostId?: string;
    private hostType?: AuditUserLogType;
    private auditFlowId?: string;

    private auditFlow?: AuditFlowDto;
    private auditLogs?: AuditUserLogDto[]= [];
    private levelNodes?: LevelNode[] = [];

    private loadForAuditFlow: boolean = true;
    private loadForAuditLog: boolean = true;


    async created() {
      this.hostId = this.$route.params.hostId;
      this.hostType = this.$route.params.hostType as AuditUserLogType;
      this.auditFlowId = this.$route.params.auditFlowId;


      let getLogPromise;
      if (this.hostType === AuditUserLogType.UserCardRefund) {
        getLogPromise = api.userCard.getLogs({id: Number(this.hostId)});
      } else if (this.hostType === AuditUserLogType.ActivityPublish) {
        getLogPromise = api.activity.getLogs({id: Number(this.hostId)});
      } else if (this.hostType === AuditUserLogType.Project) {
        getLogPromise = api.project.getLogs({id: Number(this.hostId)});
      } else if (this.hostType === AuditUserLogType.PayrollRequisition) {
        getLogPromise = api.payrollRequisition.getLogs({id: Number(this.hostId)});
      } else if (this.hostType === AuditUserLogType.ActivityRefund) {
        getLogPromise = api.refundLog.getLogs({id: Number(this.hostId)});
      } else if (this.hostType === AuditUserLogType.Reimbursement) {
        getLogPromise = api.reimbursement.getLogs({id: Number((this.hostId))});
      } else {
        this.$message({message: '不支持的审批流程类型', type: 'error'});
        return;
      }

      // @ts-ignore
      await getLogPromise.then(res => {
        this.auditLogs = res;
        this.loadForAuditLog = false;
      });

      await api.auditFlow.get({id: this.auditFlowId}).then(res => {
        this.auditFlow = res;

        const levelNodes:LevelNode[] =[];

        let auditNodeItems = this.auditFlow.auditNodes?.map((node)=>new AuditNodeItem(node,this.auditLogs!));


        auditNodeItems?.forEach(item=>{
          let filterResult = levelNodes.filter(s=>s.level === item.node.index);
          let levelNodeItem:LevelNode;
          if(filterResult.length === 0){
            levelNodeItem = {level:item.node.index!,nodes:[]};
            levelNodes.push(levelNodeItem);
          } else {
            levelNodeItem = filterResult[0];
          }

          levelNodeItem.nodes.push(item);

        });

        this.levelNodes = levelNodes.sort((a1,a2)=>a1.level - a2.level);

        this.loadForAuditFlow = false;
      });



    }

    formatDate(timestamp:string){
      if(timestamp){
        return moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
      } else {
        return '';
      }

    }

    get loading() {
      return this.loadForAuditFlow || this.loadForAuditLog;
    }

    getTimeItemColor(log:AuditUserLogDto){
      return getLogStatusColor(log);
    }

    get isNeedAllPass(){
      return this.auditFlow?.type === AuditFlowType.AuditAll;
    }



  }
